module.exports = __webpack_public_path__ + "static/media/2.6dfd6078.png";